import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';
import { accordionStyles } from './styles/accordion-styles';
import { UpdateInfoDto } from '@jobindsats/typescript-fetch-jobindsats';

@customElement('maaling-header-element')
export class MaalingHeaderElement extends JobindsatsElement(LitElement) {
    static styles = [accordionStyles,css`
        .accordion-button {
            background-color: #0000;
            text-align: left;
            display: flex;
            border: none;
            width: 100%;
            margin-top: 0px;
            padding: 0px;
            width: initial;
        }
        .accordion-content {
            padding-left: 0px;
            border: none;
            border-top: 1px solid var(--divider-color-closed);
            padding-top: 10px;
            padding-bottom: 20px;
        }
        .accordion-heading{
            border: none;
        }
        .header-content-group { 
            display: flex;
            flex-direction: column-reverse;
            align-items: flex-end;
        }
        .no-margin{
            margin: 0;
        }
        .align {
            align-self: flex-start;
        }
        .header-dates {
            color: #737373;
        }
        .option-group {
            display: flex;
            flex-direction: row;
            color: var(--main-blue);
        }
        .option-button {
            display: flex;
            flex-direction: column;
            margin: 0px 24px 0px 24px;
            cursor: pointer;
        }
        .option-icon {
            padding-bottom: 6px;
        }
        .margin-auto {
            margin: auto;
        }
        .more-info {
            margin-right: 1px;
            margin-top: 0px;
        }
        .more-info-option-group-up {
            padding: 20px 0px;
            padding-bottom: 4px;
        }
        .more-info-option-group-down {
            margin-top: 0px;
            padding: 20px 0px;
        }
        .subtext-container {
            display: flex;
            color: var(--font-color);
            align-items: baseline;
            flex-wrap: wrap;
        }
        span.avoidwrap { 
            display:inline-block; 
            margin-top: 7px;
        }
        a:hover circle{
            fill: var(--link-hover);
            stroke: var(--link-hover);
        }
        .more-info-btn {
            top: 4px;
            margin-top: 15px;
            margin-bottom: 15px;
        }
        .header-content-group .option-group {
            padding: 10px 0;
        }
        @media only screen and (min-width: 768px) {
            .header-content-group {
                flex-direction: row;
                justify-content: space-between;
            }
            .header-content-group .option-group {
                margin-top: 0;
                padding: 0
            }
            .translate {
                transform: translateY(18px);
            }
            .align {
                align-self: flex-end;
            }
        }
        `];

    static instance = 0;

    @property({
        attribute: 'sharing-url',
    })
    sharingUrl = 'sharing url not set';

    @property({
        attribute: 'info-url',
    })
    infoUrl = 'info url not set';

    @property({
        attribute: 'id',
    })
    id = ++MaalingHeaderElement.instance + 'lit-accordion';

    @property()
    updateInfo?: UpdateInfoDto;

    @state()
    expanded = false;

    @state()
    linkCopiedDialogVisible = false;


    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    sharingUrlToClipboard() {
        navigator.clipboard.writeText(this.sharingUrl);
        this.showLinkCopiedDialog();
    }

    openInfoPage() {
        window.open(this.infoUrl);
    }

    render() {
        return html`
            <div class="accordion-heading">
                <div class="header-content-group">
                        <h1 class="no-margin align">${this.title}</h1>
                    <div class="option-group translate">
                        <div title="Del måling" role="button" tabindex=0 @click=${this.sharingUrlToClipboard} class="option-button">
                            <svg width="24" height="26" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.62236 8.57675C1.72559 8.57675 0.998623 9.30372 0.998623 10.2005C0.998623 11.0972 1.72559 11.8242 2.62236 11.8242C3.51912 11.8242 4.24609 11.0972 4.24609 10.2005C4.24609 9.30372 3.51912 8.57675 2.62236 8.57675Z" fill="#003087" stroke="#003087" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.11845 4.78769C8.22169 4.78769 7.49472 5.51466 7.49472 6.41142C7.49472 7.30819 8.22169 8.03516 9.11845 8.03516C10.0152 8.03516 10.7422 7.30819 10.7422 6.41142C10.7422 5.51466 10.0152 4.78769 9.11845 4.78769Z" fill="#003087" stroke="#003087" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.62236 1.00058C1.72559 1.00058 0.998623 1.72755 0.998623 2.62431C0.998623 3.52108 1.72559 4.24805 2.62236 4.24805C3.51912 4.24805 4.24609 3.52108 4.24609 2.62431C4.24609 1.72755 3.51912 1.00058 2.62236 1.00058Z" fill="#003087" stroke="#003087" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.71875 5.59375L4.02205 3.43959" stroke="#003087" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4.02746 9.38281L7.71875 7.22866" stroke="#003087" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p class="no-margin">Del</p>
                        </div>
                        <div title="Info om måling" role="button" tabindex=0 @click=${this.openInfoPage} class="option-button">
                            <svg width="26" height="26" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="5.5" fill="#003087" stroke="#003087"/>
                                <path d="M5.50103 4.46H6.49303V8.5H5.50103V4.46ZM6.54903 2.628V3.612H5.43703V2.628H6.54903Z" fill="white"/>
                            </svg>
                            <p class="no-margin">Info</p>
                        </div>
                    </div>
                </div>
                <button @click=${this.toggleAccordion} class="accordion-button" aria-expanded="${this.expanded}" aria-controls="${this.id}">
                    <div class="option-group more-info-option-group-${this.expanded ? 'up' : 'down'}">
                        <a class="margin-auto more-info">Se ${this.expanded ? 'færre' : 'flere'} detaljer om måling<span class="icon-right glyphicon glyphicon-menu-${this.expanded ? 'up' : 'down'}"></span></a>
                    </div>
                </button>
            </div>
            <div id="${this.id}" ?hidden=${!this.expanded} class="accordion-content">
                <p class="subtext-container">
                   <span class="avoidwrap">Opdateret: ${this.updateInfo?.lastUpdate ? this.updateInfo.lastUpdate.toLocaleDateString('da-DK', {year:"numeric", month:"short", day:"numeric"})  : ''}</span>
                    &emsp;
                    <span class="avoidwrap">Næste opdatering: ${this.updateInfo?.nextUpdate ? this.updateInfo.nextUpdate.toLocaleDateString('da-DK', {year:"numeric", month:"short", day:"numeric"})  : ''}</span>
                </p>
                <slot></slot>
                <br/>
                <a href="${this.infoUrl}" target="_blank">
                    <span class="more-info-btn icon glyphicon">
                    <svg width="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="6" cy="6" r="5.5" fill="#003087" stroke="#003087"/>
                        <path d="M5.50103 4.46H6.49303V8.5H5.50103V4.46ZM6.54903 2.628V3.612H5.43703V2.628H6.54903Z" fill="white"/>
                    </svg>
                    </span>Gå til info</a>
            </div>
            <ji-dialog-element .visible=${this.linkCopiedDialogVisible} @closeDialog=${() => this.hideLinkCopiedDialog()} .title=${'Link kopieret'}>
                <p>Link til målingen er kopieret til din udklipsholder</p>
            </ji-dialog-element>
        `;
    }

    showLinkCopiedDialog() {
        this.linkCopiedDialogVisible = true;
    }

    hideLinkCopiedDialog() {
        this.linkCopiedDialogVisible = false;
    }

    toggleAccordion() {
        this.expanded = !this.expanded;
    }
}